module.exports = __webpack_public_path__ + "img/swipto.4ccaf151.png";